import * as React from 'react';
import DialogList from 'src/dialogs';

export interface ILeaseDocMenuProps {
    printPage: () => void;
    highlightDataFields: () => void;

    showDialog: (dialogName: string) => void;
}

class LeaseDocMenu extends React.Component<ILeaseDocMenuProps> {
    render() {
        return (
            <div className="lease-doc-menu">
                <div className="menu">
                    <div className="menu-option" onClick={() => this.props.showDialog(DialogList.PDF_WINDOW)}>
                        <i className="far fa-file-pdf" />
                    </div>
                    <div className="menu-option" onClick={this.props.printPage}>
                        <i className="fas fa-print" />
                    </div>
                    <div className="menu-option">
                        <a href="mailto:test@test.com">
                            <i className="far fa-envelope" />
                        </a>
                    </div>
                    <div className="menu-option" onClick={this.props.highlightDataFields}>
                        <i className="fas fa-i-cursor" />
                    </div>
                </div>
            </div>
        );
    }
}

export default LeaseDocMenu;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LeaseDocMenu.tsx